import { calculateTotals as publicCalculateTotals } from './ecom-v1-totals-calculation-totals-calculator.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const calculateTotals: MaybeContext<
  BuildRESTFunction<typeof publicCalculateTotals> & typeof publicCalculateTotals
> = /*#__PURE__*/ createRESTModule(publicCalculateTotals);

export {
  DimensionsUnit,
  SubscriptionFrequency,
  PaymentOptionType,
  ItemTypePreset,
  TaxableAddressType,
  PlatformFeeChargeType,
  PickupMethod,
  ChargeType,
  DiscountType,
  DataFetchType,
  JurisdictionType,
  RateType,
  ManualCalculationReason,
  FallbackReason,
  RuleType,
  WeightUnit,
  BalanceType,
  QuotaType,
  LimitedQuotaType,
  AdditionalFeeSource,
} from './ecom-v1-totals-calculation-totals-calculator.universal.js';
export {
  TotalsCalculationEntity,
  CalculateTotalsRequest,
  CalculateTotalsRequestCouponOneOf,
  CalculateTotalsRequestGiftCardOneOf,
  LineItem,
  CatalogReference,
  PhysicalProperties,
  Dimensions,
  Scope,
  Group,
  SubscriptionSettings,
  ServiceProperties,
  ItemType,
  ItemTypeItemTypeDataOneOf,
  TaxableAddress,
  TaxableAddressTaxableAddressDataOneOf,
  ApiV1AdditionalFee,
  V1TaxDetails,
  ModifierGroup,
  TranslatableString,
  ItemModifier,
  PlatformFee,
  Address,
  StreetAddress,
  AddressLocation,
  SelectedShippingOption,
  SelectedMemberships,
  SelectedMembership,
  CarrierShippingOption,
  ShippingOption,
  DeliveryLogistics,
  PickupDetails,
  DeliveryTimeSlot,
  ShippingPrice,
  MultiCurrencyPrice,
  OtherCharge,
  DeliveryAllocation,
  Carrier,
  Region,
  ApplicableLineItems,
  AppliedDiscount,
  AppliedDiscountDiscountSourceOneOf,
  Coupon,
  MerchantDiscount,
  DiscountRule,
  DiscountRuleName,
  LineItemDiscount,
  ItemCombination,
  ItemCombinationLineItem,
  AdditionalFee,
  TaxDetails,
  ExternalReference,
  ExtendedFields,
  GiftCardInput,
  MembershipSelection,
  ExistingMembershipSelection,
  FutureMembershipSelection,
  CalculateTotalsResponse,
  CalculatedLineItem,
  LineItemPricesData,
  ItemTaxFullDetails,
  TaxRateBreakdown,
  TaxBreakdown,
  CalculatedItemModifier,
  PriceSummary,
  GiftCard,
  TaxSummary,
  TaxCalculationDetails,
  TaxCalculationDetailsCalculationDetailsOneOf,
  AutoTaxFallbackCalculationDetails,
  ApplicationError,
  AggregatedTaxBreakdown,
  ShippingInformation,
  ShippingRegion,
  SelectedCarrierServiceOption,
  SelectedCarrierServiceOptionPrices,
  SelectedCarrierServiceOptionOtherCharge,
  CarrierServiceOption,
  CalculationErrors,
  CalculationErrorsShippingCalculationErrorOneOf,
  Details,
  DetailsKindOneOf,
  ValidationError,
  FieldViolation,
  SystemError,
  CarrierErrors,
  CarrierError,
  GiftCardCalculationError,
  MembershipOptions,
  Membership,
  MembershipName,
  MembershipPaymentCredits,
  InvalidMembership,
  ValidatedExistingMemberships,
  ExistingMembership,
  V1Membership,
  CoveredLineItem,
  ValidatedPurchasablePlans,
  PurchasablePlan,
  Benefit,
  BenefitQuotaOneOf,
  LimitedQuota,
  LineItemCoverage,
  V1AdditionalFee,
  PlatformFeeSummary,
  CalculatedPlatformFee,
  CalculateTotalsOptions,
  CalculateTotalsOptionsCouponOneOf,
  CalculateTotalsOptionsGiftCardOneOf,
} from './ecom-v1-totals-calculation-totals-calculator.universal.js';
export {
  DimensionsUnitWithLiterals,
  SubscriptionFrequencyWithLiterals,
  PaymentOptionTypeWithLiterals,
  ItemTypePresetWithLiterals,
  TaxableAddressTypeWithLiterals,
  PlatformFeeChargeTypeWithLiterals,
  PickupMethodWithLiterals,
  ChargeTypeWithLiterals,
  DiscountTypeWithLiterals,
  DataFetchTypeWithLiterals,
  JurisdictionTypeWithLiterals,
  RateTypeWithLiterals,
  ManualCalculationReasonWithLiterals,
  FallbackReasonWithLiterals,
  RuleTypeWithLiterals,
  WeightUnitWithLiterals,
  BalanceTypeWithLiterals,
  QuotaTypeWithLiterals,
  LimitedQuotaTypeWithLiterals,
  AdditionalFeeSourceWithLiterals,
} from './ecom-v1-totals-calculation-totals-calculator.universal.js';
